import React from 'react';
import { ProjectWorkItemData } from '../services/AzureDevOpsService';

interface TriagePageProps {
  projectWorkItemData: ProjectWorkItemData[];
  priorityDriverOptions: string[];
}

const TriagePage: React.FC<TriagePageProps> = ({ projectWorkItemData, priorityDriverOptions }) => {
        React.useEffect(() => {
        document.title = "Triage";
      }, []);

  return (
    <div>
      <h1>Triage</h1>
      <p>This is the Triage page of the application.</p>
    </div>
  );
};

export default TriagePage;
